export default __webpack_public_path__ + "static/media/My_car_website_images-13_22.f3657624.webp";